import { Button, Code, Flex, HStack, Heading, VStack } from "@chakra-ui/react";
import { ReactElement, useMemo, useState } from "react";
import SetupTool from "./SetupTool";

interface ErrorViewWithSetupProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorViewWithSetup(
  props: ErrorViewWithSetupProps
): ReactElement {
  const { error, resetErrorBoundary } = props;

  const message = useMemo(
    () => error?.message ?? JSON.stringify(error),
    [error]
  );

  const [inSetup, setInSetup] = useState(false);

  return (
    <Flex w="100%" h="70vh" justify="center" align="center">
      {inSetup ? (
        <SetupTool />
      ) : (
        <VStack
          spacing="6"
          bg="gray.100"
          rounded="lg"
          p="8"
          maxW="36rem"
          overflow=""
        >
          <Heading>Oops! Something went wrong</Heading>
          <Code
            display="block"
            w="100%"
            wordBreak="break-word"
            bg="gray.50"
            fontSize="md"
            borderWidth="2px"
            overflowY="auto"
          >
            {message}
          </Code>
          <HStack w="100%" justify="space-between">
            <Button
              variant="outline"
              bg="white"
              onClick={() => setInSetup(true)}
            >
              Enter Setup
            </Button>
            <Button colorScheme="blue" onClick={resetErrorBoundary}>
              Try Again
            </Button>
          </HStack>
        </VStack>
      )}
    </Flex>
  );
}
